import { render, staticRenderFns } from "./JasperShow.vue?vue&type=template&id=1b8e107a&"
import script from "./JasperShow.vue?vue&type=script&lang=js&"
export * from "./JasperShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports